import React, { useEffect, useState } from 'react';
import './Landing.css';

function Landing({ tenantId }) {
  const [tenant, setTenant] = useState(null);
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showScheduleForm, setShowScheduleForm] = useState(false);

  useEffect(() => {
    async function fetchData() {
      try {
        const [tenantRes, servicesRes] = await Promise.all([
          fetch(`http://${window.location.hostname}:8000/public/tenant/${tenantId}`),
          fetch(`http://${window.location.hostname}:8000/public/services/${tenantId}`)
        ]);

        if (tenantRes.ok && servicesRes.ok) {
          const tenantData = await tenantRes.json();
          const servicesData = await servicesRes.json();
          setTenant(tenantData);
          setServices(servicesData.services);
        }
      } catch (err) {
        console.error("Failed to load public data:", err);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, [tenantId]);

  if (loading) {
    return (
      <div className="landing-loader">
        <div className="spinner"></div>
      </div>
    );
  }

  if (!tenant) {
    return (
      <div className="landing-404">
        <h1>Oficina não encontrada</h1>
        <p>A oficina que você está procurando não existe ou está indisponível.</p>
      </div>
    );
  }

  return (
    <div className="landing-container">
      {/* Header */}
      <header className="landing-header">
        <div className="landing-logo-placeholder">
           {tenant.name[0]}
        </div>
        <nav className="landing-nav">
          <a href="#services">Serviços</a>
          <a href="#location">Localização</a>
          <a href="#contact">Contato</a>
        </nav>
      </header>

      {/* Hero Section */}
      <section className="landing-hero">
        <div className="hero-content animate-fade-in-up">
          <div className="badge">Nova Experiência Automotiva</div>
          <h1>{tenant.name}</h1>
          <p className="hero-subtitle">Mecânica de precisão aliada a inteligência artificial. Agende seu serviço e converse com Barker, nosso assistente virtual.</p>
          <div className="hero-actions">
            <button className="btn-primary-glow" onClick={() => setShowScheduleForm(true)}>Agendar pelo Bot</button>
            <a href="#services" className="btn-secondary">Ver Serviços</a>
          </div>
        </div>
        <div className="hero-image-placeholder animate-fade-in">
          {/* Abstract Workshop Graphic */}
          <div className="abstract-car">
            <div className="car-line"></div>
            <div className="car-glow"></div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="landing-services">
        <h2 className="section-title">Nossos Serviços</h2>
        <div className="services-grid">
          {services.length > 0 ? services.map(srv => (
            <div key={srv.id} className="service-card">
              <div className="service-icon">🛠️</div>
              <h3>{srv.name}</h3>
              <p>{srv.description}</p>
              <div className="price">R$ {parseFloat(srv.price).toFixed(2)}</div>
            </div>
          )) : (
            <p style={{color: '#94a3b8', textAlign: 'center', width: '100%'}}>Nenhum serviço cadastrado no momento.</p>
          )}
        </div>
      </section>

      {/* AI Assistant Section */}
      <section className="landing-ai-banner">
        <div className="ai-content">
           <h2>Conheça <span style={{color: '#fbbf24'}}>Barker</span></h2>
           <p>Nosso assistente de IA no WhatsApp agenda serviços, analisa orçamentos e tira dúvidas sobre manutenção em tempo real.</p>
        </div>
        <div className="ai-illustration">🤖</div>
      </section>

      {/* Location / Contact */}
      <section id="location" className="landing-info-section">
         <div className="info-box">
            <h3>📍 Localização</h3>
            <p>{tenant.address || 'Consulte nosso atendimento'}</p>
         </div>
         <div className="info-box" id="contact">
            <h3>📞 Contato</h3>
            <p>Telefone: {tenant.phone || '(00) 00000-0000'}<br/>Aberto de Seg a Sex: 8h às 18h</p>
         </div>
      </section>

      {/* Footer */}
      <footer className="landing-footer">
        <p>&copy; {new Date().getFullYear()} {tenant.name} - Powered by StackFab</p>
      </footer>

      {/* Schedule Modal */}
      {showScheduleForm && (
        <div className="modal-overlay" onClick={() => setShowScheduleForm(false)}>
          <div className="modal-content glass-panel" onClick={e => e.stopPropagation()}>
            <h2>Agendamento Inteligente</h2>
            <p>Converse com nosso assistente virtual via WhatsApp para encontrar o melhor horário.</p>
            <div style={{ marginTop: '2rem', textAlign: 'center' }}>
               <button 
                className="btn-whatsapp"
                onClick={() => window.open(`https://wa.me/${tenant.phone?.replace(/\D/g, '') || '55'}/?text=Olá Barker, quero agendar um serviço na oficina ${tenant.name}`, '_blank')}
              >
                Abrir WhatsApp
              </button>
           </div>
            <button className="btn-close" onClick={() => setShowScheduleForm(false)}>Fechar</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Landing;
